// src/components/EnviarModal.jsx  —  v3.0
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import api from '../services/api';
import './EnviarModal.css';

import {
  FiX,
  FiSend,
  FiMessageSquare,
  FiMail,
  FiCheckCircle,
  FiHash,
} from 'react-icons/fi';

// Ícone WhatsApp SVG inline
const WhatsAppIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

export default function EnviarModal({ isOpen, onClose, quoteData }) {
  const [telefone,        setTelefone]        = useState('');
  const [email,           setEmail]           = useState('');
  const [sendingSms,      setSendingSms]      = useState(false);
  const [sendingEmail,    setSendingEmail]    = useState(false);
  const [sendingWhatsapp, setSendingWhatsapp] = useState(false);
  const [sentSms,         setSentSms]         = useState(false);
  const [sentEmail,       setSentEmail]       = useState(false);
  const [sentWhatsapp,    setSentWhatsapp]    = useState(false);

  useEffect(() => {
    if (!isOpen) {
      // Reset ao fechar
      setSentSms(false);
      setSentEmail(false);
      setSentWhatsapp(false);
      return;
    }
    if (quoteData?.cliente) {
      setTelefone(quoteData.cliente.telefone || '');
      setEmail(quoteData.cliente.email || '');
    } else {
      setTelefone('');
      setEmail('');
    }
  }, [isOpen, quoteData]);

  if (!isOpen) return null;

  const handleSendSms = async () => {
    if (!telefone.trim()) { toast.warn('Informe o número de telefone.'); return; }
    setSendingSms(true);
    try {
      await api.post(`/api/orcamentos/${quoteData.id}/enviar-sms`, { telefone });
      setSentSms(true);
      toast.success('SMS enviado com sucesso!');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Falha ao enviar SMS.');
    } finally {
      setSendingSms(false);
    }
  };

  const handleSendEmail = async () => {
    if (!email.trim() || !email.includes('@')) { toast.warn('Informe um e-mail válido.'); return; }
    setSendingEmail(true);
    try {
      await api.post(`/api/orcamentos/${quoteData.id}/enviar-email`, { email });
      setSentEmail(true);
      toast.success('E-mail enviado com sucesso!');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Falha ao enviar e-mail.');
    } finally {
      setSendingEmail(false);
    }
  };

  const handleSendWhatsapp = async () => {
    if (!telefone.trim()) { toast.warn('Informe o número de telefone/WhatsApp.'); return; }
    setSendingWhatsapp(true);
    try {
      await api.post(`/api/orcamentos/${quoteData.id}/enviar-whatsapp`, { telefone });
      setSentWhatsapp(true);
      toast.success('WhatsApp enviado com sucesso!');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Falha ao enviar WhatsApp.');
    } finally {
      setSendingWhatsapp(false);
    }
  };

  const busy = sendingSms || sendingEmail || sendingWhatsapp;

  return (
    <div className="em-overlay" onClick={onClose}>
      <div className="em-modal" onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="em-header">
          <div className="em-header-left">
            <FiSend className="em-header-icon" />
            <div>
              <h2 className="em-title">Enviar Cotação</h2>
              <p className="em-subtitle">
                <FiHash size={11} /> {quoteData?.uid || '—'}
              </p>
            </div>
          </div>
          <button className="em-close" onClick={onClose}><FiX /></button>
        </div>

        {/* Canais */}
        <div className="em-channels">

          {/* SMS */}
          <div className={`em-channel ${sentSms ? 'em-channel--sent' : ''}`}>
            <div className="em-channel-header">
              <div className="em-channel-icon em-channel-icon--sms">
                <FiMessageSquare size={16} />
              </div>
              <div>
                <strong>SMS</strong>
                <span>Link direto para a cotação</span>
              </div>
              {sentSms && <FiCheckCircle className="em-sent-check" />}
            </div>
            <div className="em-channel-body">
              <label className="em-label">Telefone (com DDD)</label>
              <input
                type="tel"
                className="em-input"
                value={telefone}
                placeholder="(11) 99999-9999"
                onChange={(e) => setTelefone(e.target.value)}
                disabled={sentSms || sentWhatsapp} // Trava se enviado por SMS ou Whats para preservar integridade do input no fluxo atual
              />
            </div>
            <button
              className={`em-btn em-btn--sms ${sentSms ? 'em-btn--sent' : ''}`}
              onClick={handleSendSms}
              disabled={busy || sentSms}
            >
              {sentSms ? (
                <><FiCheckCircle size={14} /> Enviado</>
              ) : sendingSms ? (
                <><span className="em-spinner" /> Enviando...</>
              ) : (
                <><FiSend size={14} /> Enviar SMS</>
              )}
            </button>
          </div>

          {/* WhatsApp */}
          <div className={`em-channel ${sentWhatsapp ? 'em-channel--sent' : ''}`}>
            <div className="em-channel-header">
              <div className="em-channel-icon em-channel-icon--whatsapp">
                <WhatsAppIcon />
              </div>
              <div>
                <strong>WhatsApp</strong>
                <span>Notificação instantânea estruturada</span>
              </div>
              {sentWhatsapp && <FiCheckCircle className="em-sent-check" />}
            </div>
            <div className="em-channel-body">
              <label className="em-label">Telefone / WhatsApp (com DDD)</label>
              <input
                type="tel"
                className="em-input"
                value={telefone}
                placeholder="(11) 99999-9999"
                onChange={(e) => setTelefone(e.target.value)}
                disabled={sentSms || sentWhatsapp}
              />
            </div>
            <button
              className={`em-btn em-btn--whatsapp ${sentWhatsapp ? 'em-btn--sent' : ''}`}
              style={{ backgroundColor: sentWhatsapp ? '' : '#25D366', color: '#fff' }}
              onClick={handleSendWhatsapp}
              disabled={busy || sentWhatsapp}
            >
              {sentWhatsapp ? (
                <><FiCheckCircle size={14} /> Enviado</>
              ) : sendingWhatsapp ? (
                <><span className="em-spinner" /> Enviando...</>
              ) : (
                <><FiSend size={14} /> Enviar WhatsApp</>
              )}
            </button>
          </div>

          {/* E-mail */}
          <div className={`em-channel ${sentEmail ? 'em-channel--sent' : ''}`}>
            <div className="em-channel-header">
              <div className="em-channel-icon em-channel-icon--email">
                <FiMail size={16} />
              </div>
              <div>
                <strong>E-mail</strong>
                <span>Detalhes completos formatados</span>
              </div>
              {sentEmail && <FiCheckCircle className="em-sent-check" />}
            </div>
            <div className="em-channel-body">
              <label className="em-label">Endereço de e-mail</label>
              <input
                type="email"
                className="em-input"
                value={email}
                placeholder="cliente@exemplo.com"
                onChange={(e) => setEmail(e.target.value)}
                disabled={sentEmail}
              />
            </div>
            <button
              className={`em-btn em-btn--email ${sentEmail ? 'em-btn--sent' : ''}`}
              onClick={handleSendEmail}
              disabled={busy || sentEmail}
            >
              {sentEmail ? (
                <><FiCheckCircle size={14} /> Enviado</>
              ) : sendingEmail ? (
                <><span className="em-spinner" /> Enviando...</>
              ) : (
                <><FiSend size={14} /> Enviar E-mail</>
              )}
            </button>
          </div>

        </div>

        {/* Footer */}
        <div className="em-footer">
          <button className="em-btn-fechar" onClick={onClose}>
            {sentSms || sentEmail || sentWhatsapp ? 'Concluído' : 'Cancelar'}
          </button>
        </div>

      </div>
    </div>
  );
}